__turbopack_context__.v({
  "infoPanel": "shops-map-module-scss-module__PV9Kha__infoPanel",
  "infoPanel__open": "shops-map-module-scss-module__PV9Kha__infoPanel__open",
  "map": "shops-map-module-scss-module__PV9Kha__map",
  "root": "shops-map-module-scss-module__PV9Kha__root",
});
